const POOL = 'couponPoolId';
const ONLY_VALID = 'onlyValid';
const ONLY_AVAILABLE = 'onlyAvailable';
const ARCHIVED = 'archived';
const PAGE = 'page';

export { POOL, ONLY_VALID, ONLY_AVAILABLE, ARCHIVED, PAGE };
